import React, { useEffect } from 'react';
import { Spin } from 'antd';

// Admin handoff landing: reads a short-lived token + org id from the URL hash,
// stores them, then reloads into the portal scoped to that company.
export default function Impersonate() {
  useEffect(() => {
    const raw = window.location.hash.replace(/^#/, '');
    const params = new URLSearchParams(raw);
    const token = params.get('token');
    const org = params.get('org');

    localStorage.removeItem('token');
    localStorage.removeItem('impersonateOrg');

    if (token && org) {
      localStorage.setItem('token', token);
      localStorage.setItem('impersonateOrg', org);
      window.location.replace('/');
    } else {
      window.location.replace('/login');
    }
  }, []);

  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }}>
      <Spin size="large" tip="Opening portal…" />
    </div>
  );
}
